
import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const HOME_SECTION_API_URL = `${process.env.REACT_APP_API_URL}/home`; // Replace with your actual API URL



// Fetch all home sections
export const fetchHomeSections = async () => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${HOME_SECTION_API_URL}/home-section`, { headers: customHeaders });
  return response.data;
};

// Create a new home section
export const addHomeSection = async (newHomeSection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.post(HOME_SECTION_API_URL, newHomeSection, {
    headers: customHeaders
  });
  return response.data;
};

// Edit an existing home section
export const updateHomeSection = async (updatedHomeSection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.put(`${HOME_SECTION_API_URL}`, updatedHomeSection, {
    headers: customHeaders
  });
  return response.data;
};
